import classnames from "classnames";
import { FC, useCallback, useEffect } from "react";
import { useFormik } from "formik";
import { useTableContext } from "./context";

export const TablePagerNav: FC = () => {
  const { table } = useTableContext();

  if (!table) {
    throw new Error("table is undefined");
  }

  const { gotoPage, pageCount = 0 } = table;

  const firstPage = useCallback(() => gotoPage!(0), [gotoPage]);
  const lastPage = useCallback(() => gotoPage!(pageCount - 1), [gotoPage, pageCount]);

  return (
    <div className="btn-toolbar justify-content-center align-items-center" role="toolbar">
      <div className="btn-group me-2 btn-group-sm" role="group">
        <button onClick={firstPage}
          className={classnames(
            "btn btn-outline-primary btn-active-light-primary btn-icon",
            { disabled: !table?.canPreviousPage }
          )}>
          <span className="fw-bold bi bi-chevron-double-left" />
        </button>
        <button onClick={table?.previousPage}
          className={classnames(
            "btn btn-outline-primary btn-active-light-primary btn-icon",
            { disabled: !table?.canPreviousPage }
          )}>
          <span className="fw-bold bi bi-chevron-left" />
        </button>
        <PageIndexForm />
        <button onClick={table?.nextPage}
          className={classnames(
            "btn btn-outline-primary btn-active-light-primary btn-icon",
            { disabled: !table?.canNextPage }
          )}>
          <span className="fw-bold bi bi-chevron-right" />
        </button>
        <button onClick={lastPage}
          className={classnames(
            "btn btn-outline-primary btn-active-light-primary btn-icon",
            { disabled: !table?.canNextPage }
          )}>
          <span className="fw-bold bi bi-chevron-double-right" />
        </button>
      </div>
    </div>
  );
};

const PageIndexForm: FC = () => {
  const { table } = useTableContext();

  if (!table) {
    throw new Error("table is undefined");
  }

  const { gotoPage, state: { pageIndex } } = table;

  const { values, handleSubmit, handleChange, handleBlur, setFieldValue } = useFormik({
    initialValues: { pageIndex },
    onSubmit(values) {
      gotoPage!(Number(values.pageIndex ?? 1) - 1);
    },
  });

  useEffect(() => {
    setFieldValue("pageIndex", pageIndex + 1);
  }, [setFieldValue, pageIndex]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="input-group input-group-sm" style={{ minWidth: "120px" }}>
        <input
          type="number"
          name="pageIndex"
          className="form-control"
          min="1"
          max={table!.pageCount}
          style={{ width: "62px" }}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.pageIndex} />
        <span className="input-group-text">
          de {table!.pageCount}
        </span>
      </div>
    </form>
  );
};
